import React from 'react';
import { configure, mount } from 'enzyme';
import Adapter from 'enzyme-adapter-react-16';
import LinRemoteRepository from './LinRemoteRepository';
import { LINUX, LINUX_11_5_03 } from '../../../../Utils/Constants';
import { loadData } from '../../../../Utils/DataLoader';
import { pageObjects } from '../../../../Utils/LinuxDataLoader';
import { initializePageObjectsMap } from '../../../../Utils/PageObjectsMapUtil';

configure({ adapter: new Adapter() });

let wrapper = null;
describe('LinRemoteRepository', () => {
    loadData(LINUX_11_5_03);
    initializePageObjectsMap(pageObjects);
    beforeEach(() => {
        jest.mock('../../../Navigation/Navigation', () => 'Nav');
        wrapper = mount(
            <LinRemoteRepository
                nextStep={jest.fn()}
                backStep={jest.fn()}
                steps={2}
                getOriginState={jest.fn((value) =>
                    value === 'repositoryActive' ? false : 'mock value'
                )}
                setOriginState={jest.fn()}
                setBasicState={jest.fn()}
                deepestStep={2}
                useOs={LINUX}
            />
        );
    });

    // DB hostname test
    it('Test DBHost input with empty should show error', () => {
        wrapper
            .find('.ant-input')
            .at(0)
            .simulate('change', {
                target: {
                    value: '',
                },
            });

        expect(
            wrapper.find('.ant-form-item-control').at(0).hasClass('has-error')
        ).toEqual(true);
    });

    it('Test DBHost input with invalid host name should show error', () => {
        wrapper
            .find('.ant-input')
            .at(0)
            .simulate('change', {
                target: {
                    value: 'Not Valid Host',
                },
            });
        expect(
            wrapper.find('.ant-form-item-control').at(0).hasClass('has-error')
        ).toEqual(true);
    });

    it('Test DBHost input with valid host name should show success', () => {
        wrapper
            .find('.ant-input')
            .at(0)
            .simulate('change', {
                target: {
                    value: 'postgress.database.host',
                },
            });
        expect(
            wrapper.find('.ant-form-item-control').at(0).hasClass('has-error')
        ).toEqual(false);
    });

    // Port test
    it('Test port input with invalid value should show error', () => {
        wrapper
            .find('.ant-input')
            .at(1)
            .simulate('change', {
                target: {
                    value: '1234567',
                },
            });
        expect(
            wrapper.find('.ant-form-item-control').at(1).hasClass('has-error')
        ).toEqual(true);
    });

    it('Test port input with valid value should show success', () => {
        wrapper
            .find('.ant-input')
            .at(1)
            .simulate('change', {
                target: {
                    value: '5432',
                },
            });
        expect(
            wrapper.find('.ant-form-item-control').at(1).hasClass('has-error')
        ).toEqual(false);
    });

    //Username test
    it('Test Username input with empty should show error', () => {
        wrapper
            .find('.ant-input')
            .at(2)
            .simulate('change', {
                target: {
                    value: '',
                },
            });
        expect(
            wrapper.find('.ant-form-item-control').at(2).hasClass('has-error')
        ).toEqual(true);
    });

    it('Test Username input with non-empty should show success', () => {
        wrapper
            .find('.ant-input')
            .at(2)
            .simulate('change', {
                target: {
                    value: 'username',
                },
            });
        expect(
            wrapper.find('.ant-form-item-control').at(2).hasClass('has-error')
        ).toEqual(false);
    });

    //Username test

    it('Test Password input with empty should show error', () => {
        wrapper
            .find('.ant-input')
            .at(3)
            .simulate('change', {
                target: {
                    value: '',
                },
            });
        expect(
            wrapper.find('.ant-form-item-control').at(3).hasClass('has-error')
        ).toEqual(true);
    });

    it('Test Password input with non-empty should show success', () => {
        wrapper
            .find('.ant-input')
            .at(3)
            .simulate('change', {
                target: {
                    value: 'password',
                },
            });
        expect(
            wrapper.find('.ant-form-item-control').at(3).hasClass('has-error')
        ).toEqual(false);
    });
});
